import { Outlet } from "react-router-dom";
import Login from "../../Auth/Login";
import { useDispatch, useSelector } from "react-redux";
import StudentNav from "./StudentNav";
import DashHeader from "../../components/DashHeader";
import DashMobileNav from "../../components/DashMobileNav";
import { useTranslation } from "react-i18next";

export default function StudentDashboard(){
    const { t } = useTranslation();
    const STUDENT_NAV_ITEMS = [
        { to: '/home/student', icon: 'fa-light fa-grid-2', label: t('studentDashboard.dashboard'), end: true },
        { to: '/home/chat', icon: 'fa-light fa-message-lines', label: t('studentDashboard.messages'), badge: 'unread' },
        { to: '/home/my-lessons', icon: 'fa-light fa-chalkboard-user', label: t('studentDashboard.my_lessons') },
        { to: '/home/save-course', icon: 'fa-light fa-heart', label: t('studentDashboard.saved_courses') },
        { to: '/home/transactions', icon: 'fa-light fa-list', label: t('studentDashboard.transactions') },
        { to: '/home/settings/profile', icon: 'fa-light fa-user-gear', label: t('studentDashboard.settings') },
        { to: '/home/help', icon: 'fa-light fa-circle-info', label: t('studentNav.help') },
    ];
    const dispatch = useDispatch();
    const { user, accessToken } = useSelector((state) => state.authReducer);
  if (!accessToken) {
    return (
      <>
        <Login />
      </>
    );
  }
    return (
        <div className="dash-shell">
        <DashHeader role="student" />
      <div className="page-content student-panel">
        <div className="container">
          <DashMobileNav items={STUDENT_NAV_ITEMS} />
          <div className="row">
            <div className="col-xl-3 col-lg-3 panelSidebar">
              <StudentNav />
            </div>
            <div className="col-lg-9 col-xl-9 col-12">
             
            <Outlet/>

            </div>
          </div>
        </div>
      </div>
        </div>
    )
}